import { render } from "./budget_information_profitAndLossStructuresById.vue?vue&type=template&id=f23dd02a"
import script from "./budget_information_profitAndLossStructuresById.vue?vue&type=script&lang=js"
export * from "./budget_information_profitAndLossStructuresById.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__